import { RouteRecordRaw } from "vue-router";
const TrialBalance: RouteRecordRaw = {
  path: "trialBalance",
  component: () => import("@/views/accounts/index.vue"),
  meta: {
    title: "Accounts",
  },
  children: [
    {
      path: "",
      name: "trialBalance",
      component: () => import("@/views/accounts/trialBalance/pages/index.vue"),
      meta: {
        pageId: 17010300,
        role: "view",
        title: "TrialBalance",
      },
    },
  ],
};

export default TrialBalance;
